import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTheme } from '@emotion/react';
import { motion } from 'framer-motion';

const COLORS_LIGHT = ['#6366F1', '#10B981', '#F59E42', '#EC4899', '#3B82F6', '#F87171', '#34D399', '#FBBF24'];
const COLORS_DARK = ['#818CF8', '#6EE7B7', '#FBBF24', '#F472B6', '#60A5FA', '#FCA5A5', '#4ADE80', '#FDE68A'];

const DepartmentPieChart = ({ data, title = "Department-wise Calls" }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const COLORS = isDark ? COLORS_DARK : COLORS_LIGHT;

  // Define sentiment-specific colors
  const sentimentColors = {
    positive: '#10B981', // Green
    negative: '#EF4444', // Red
    neutral: '#6B7280',  // Gray
    Positive: '#10B981',
    Negative: '#EF4444',
    Neutral: '#6B7280'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl shadow-xl p-6 transition-colors duration-300 ${isDark ? 'bg-gray-900' : 'bg-white'}`}
    >
      <div className="flex justify-between items-center mb-2">
        <h2 className={`text-xl font-bold ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>{title}</h2>
        <span className="text-gray-400 text-sm">
          {title.includes('Sentiment') ? 'Distribution by sentiment' : 'Distribution by departments'}
        </span>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={sentimentColors[entry.name] || COLORS[index % COLORS.length]} 
              />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value, name) => [`${value.toFixed(1)}%`, name]}
            labelFormatter={(label) => `${label} Sentiment`}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </motion.div>
  );
};

export default DepartmentPieChart; 